import type { HTMLChakraProps } from '@chakra-ui/react'
import { chakra } from '@chakra-ui/react'

export const Spider = (props: HTMLChakraProps<'svg'>) => (
  <chakra.svg
    height='auto'
    width='auto'
    viewBox='0 0 503 576'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clip-path='url(#clip0_137_175)'>
      <path
        d='M414.589 382.864V194.915L251.825 100.941L89.0618 194.915V382.864L251.825 476.838L414.589 382.864Z'
        stroke='white'
        stroke-opacity='0.2'
        stroke-miterlimit='10'
        stroke-dasharray='2 2'
      />
      <path
        d='M463.431 411.056V166.723L251.825 44.5564L40.2202 166.723V411.056L251.825 533.223L463.431 411.056Z'
        stroke='white'
        stroke-opacity='0.2'
        stroke-miterlimit='10'
      />
      <path
        d='M251.825 411.683V570.813'
        stroke='white'
        stroke-opacity='0.2'
        stroke-miterlimit='10'
      />
      <path
        d='M251.825 6.96667V163.591'
        stroke='white'
        stroke-opacity='0.2'
        stroke-miterlimit='10'
      />
      <path
        d='M495.983 429.851L360.334 351.539'
        stroke='white'
        stroke-opacity='0.2'
        stroke-miterlimit='10'
      />
      <path
        d='M143.316 226.24L7.66748 147.928'
        stroke='white'
        stroke-opacity='0.2'
        stroke-miterlimit='10'
      />
      <path
        d='M360.334 226.24L495.983 147.928'
        stroke='white'
        stroke-opacity='0.2'
        stroke-miterlimit='10'
      />
      <path
        d='M7.66748 429.851L143.316 351.539'
        stroke='white'
        stroke-opacity='0.2'
        stroke-miterlimit='10'
      />
      <path
        d='M251.825 163.591L143.316 226.24L251.825 288.89L360.334 226.24L251.825 163.591Z'
        fill='url(#paint0_linear_137_175)'
      />
      <path
        d='M251.825 288.89V414.189L360.334 351.539V226.24L251.825 288.89Z'
        fill='black'
        fill-opacity='0.3'
      />
      <path
        d='M7.66763 154.945C11.5429 154.945 14.6844 151.803 14.6844 147.928C14.6844 144.053 11.5429 140.911 7.66763 140.911C3.79239 140.911 0.650879 144.053 0.650879 147.928C0.650879 151.803 3.79239 154.945 7.66763 154.945Z'
        fill='#E53E3E'
      />
      <path
        d='M127.905 92.2953C131.78 92.2953 134.921 89.1538 134.921 85.2786C134.921 81.4033 131.78 78.2618 127.905 78.2618C124.029 78.2618 120.888 81.4033 120.888 85.2786C120.888 89.1538 124.029 92.2953 127.905 92.2953Z'
        fill='white'
        fill-opacity='0.2'
      />
      <path
        d='M7.49209 295.906C11.3673 295.906 14.5088 292.765 14.5088 288.89C14.5088 285.014 11.3673 281.873 7.49209 281.873C3.61685 281.873 0.475342 285.014 0.475342 288.89C0.475342 292.765 3.61685 295.906 7.49209 295.906Z'
        fill='white'
        fill-opacity='0.2'
      />
      <path
        d='M379.906 511.621C383.781 511.621 386.923 508.48 386.923 504.605C386.923 500.729 383.781 497.588 379.906 497.588C376.031 497.588 372.889 500.729 372.889 504.605C372.889 508.48 376.031 511.621 379.906 511.621Z'
        fill='white'
        fill-opacity='0.2'
      />
      <path
        d='M495.983 154.945C499.858 154.945 503 151.803 503 147.928C503 144.053 499.858 140.911 495.983 140.911C492.108 140.911 488.966 144.053 488.966 147.928C488.966 151.803 492.108 154.945 495.983 154.945Z'
        fill='#F6E05E'
      />
      <path
        d='M251.825 14.0335C255.701 14.0335 258.842 10.892 258.842 7.01675C258.842 3.14151 255.701 0 251.825 0C247.95 0 244.809 3.14151 244.809 7.01675C244.809 10.892 247.95 14.0335 251.825 14.0335Z'
        fill='#C05621'
      />
      <path
        d='M495.983 436.868C499.858 436.868 503 433.726 503 429.851C503 425.976 499.858 422.834 495.983 422.834C492.108 422.834 488.966 425.976 488.966 429.851C488.966 433.726 492.108 436.868 495.983 436.868Z'
        fill='#00CD98'
      />
      <path
        d='M251.825 576C255.701 576 258.842 572.859 258.842 568.983C258.842 565.108 255.701 561.967 251.825 561.967C247.95 561.967 244.809 565.108 244.809 568.983C244.809 572.859 247.95 576 251.825 576Z'
        fill='#486FF9'
      />
      <path
        d='M7.66763 436.868C11.5429 436.868 14.6844 433.726 14.6844 429.851C14.6844 425.976 11.5429 422.834 7.66763 422.834C3.79239 422.834 0.650879 425.976 0.650879 429.851C0.650879 433.726 3.79239 436.868 7.66763 436.868Z'
        fill='#F687B3'
      />
      <g filter='url(#filter0_d_137_175)'>
        <path
          d='M251.825 163.591L360.334 226.24V351.539L251.825 414.189L143.316 351.539V226.24L251.825 163.591ZM251.825 160.709L250.572 161.435L142.063 224.085L140.81 224.812V351.564V353.018L142.063 353.744L250.572 416.394L251.825 417.121L253.078 416.394L361.587 353.744L362.84 353.018V224.837L361.587 224.11L253.078 161.46L251.825 160.734V160.709Z'
          fill='url(#paint1_linear_137_175)'
        />
      </g>
      <path
        d='M251.825 171.935C247.214 171.935 243.48 168.176 243.48 163.591C243.48 159.005 247.239 155.246 251.825 155.246C256.411 155.246 260.17 159.005 260.17 163.591C260.17 168.176 256.411 171.935 251.825 171.935Z'
        fill='white'
      />
      <path
        d='M251.825 157.752C255.058 157.752 257.664 160.358 257.664 163.591C257.664 166.823 255.058 169.429 251.825 169.429C248.593 169.429 245.986 166.823 245.986 163.591C245.986 160.358 248.593 157.752 251.825 157.752ZM251.825 152.74C245.836 152.74 240.974 157.601 240.974 163.591C240.974 169.58 245.836 174.441 251.825 174.441C257.815 174.441 262.676 169.58 262.676 163.591C262.676 157.601 257.815 152.74 251.825 152.74Z'
        fill='white'
        fill-opacity='0.3'
      />
      <path
        d='M251.825 420.028C247.214 420.028 243.48 416.269 243.48 411.683C243.48 407.097 247.239 403.338 251.825 403.338C256.411 403.338 260.17 407.097 260.17 411.683C260.17 416.269 256.411 420.028 251.825 420.028Z'
        fill='white'
      />
      <path
        d='M251.825 405.844C255.058 405.844 257.664 408.45 257.664 411.683C257.664 414.915 255.058 417.522 251.825 417.522C248.593 417.522 245.986 414.915 245.986 411.683C245.986 408.45 248.593 405.844 251.825 405.844ZM251.825 400.832C245.836 400.832 240.974 405.693 240.974 411.683C240.974 417.672 245.836 422.534 251.825 422.534C257.815 422.534 262.676 417.672 262.676 411.683C262.676 405.693 257.815 400.832 251.825 400.832Z'
        fill='white'
        fill-opacity='0.2'
      />
      <path
        d='M143.316 359.884C138.705 359.884 134.971 356.125 134.971 351.539C134.971 346.953 138.73 343.194 143.316 343.194C147.902 343.194 151.661 346.953 151.661 351.539C151.661 356.125 147.902 359.884 143.316 359.884Z'
        fill='white'
      />
      <path
        d='M143.316 345.7C146.549 345.7 149.155 348.306 149.155 351.539C149.155 354.772 146.549 357.378 143.316 357.378C140.084 357.378 137.477 354.772 137.477 351.539C137.477 348.306 140.084 345.7 143.316 345.7ZM143.316 340.688C137.327 340.688 132.465 345.55 132.465 351.539C132.465 357.528 137.327 362.39 143.316 362.39C149.306 362.39 154.167 357.528 154.167 351.539C154.167 345.55 149.306 340.688 143.316 340.688Z'
        fill='white'
        fill-opacity='0.2'
      />
    </g>
    <defs>
      <filter
        id='filter0_d_137_175'
        x='120.81'
        y='144.709'
        width='262.03'
        height='296.412'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='10' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_137_175' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_137_175' result='shape' />
      </filter>
      <linearGradient
        id='paint0_linear_137_175'
        x1='251.825'
        y1='163.591'
        x2='248.866'
        y2='415.66'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#3BE0FF' />
        <stop offset='1' stop-color='#2A17A7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_137_175'
        x1='251.825'
        y1='160.709'
        x2='251.825'
        y2='417.121'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#3BE0FF' />
        <stop offset='1' stop-color='#2A17A7' />
      </linearGradient>
      <clipPath id='clip0_137_175'>
        <rect width='502.525' height='576' fill='white' transform='translate(0.475342)' />
      </clipPath>
    </defs>
  </chakra.svg>
)
